// extracted by mini-css-extract-plugin
export default {"divider":"styles-module__divider--kVovd","content":"styles-module__content--eE45y","error_image":"styles-module__error_image--sHaCK"};